import script from "./groupapi.vue?vue&type=script&setup=true&lang=js"
export * from "./groupapi.vue?vue&type=script&setup=true&lang=js"

import "./groupapi.vue?vue&type=style&index=0&id=11835611&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11835611"]])

export default __exports__